import { useState, useEffect } from 'react'

export const useUpdateBodyParams = ({ specificFilters, includeThreatRating, currentPage, pageSize, sortBy }) => {
  const { associationFilters, indicatorTypeFilter, indicatorValue } = specificFilters
  const [bodyParams, setBodyParams] = useState({ })

  useEffect(() => {
    let updatedParams = {
      limit: pageSize,
      offset: (currentPage - 1) * pageSize,
      attribution: associationFilters,
      search: indicatorValue,
      filters: (indicatorTypeFilter && indicatorTypeFilter.includes('hash')) ? ['sha256'] : indicatorTypeFilter,
    }

    if (includeThreatRating) {
      updatedParams.includeThreatRating = true
    }

    if (sortBy && sortBy.length > 0) {
      const { id, desc } = sortBy[0]
      updatedParams = {
        ...updatedParams,
        sortBy: [id],
        sortOrder: !desc ? 'desc' : 'asc',
      }
    }
    setBodyParams(updatedParams)
  }, [associationFilters, indicatorTypeFilter, indicatorValue, includeThreatRating, currentPage, pageSize, sortBy])

  return bodyParams
}
